import React, { useEffect, useRef, useState } from "react"
import { useParams, withRouter } from "react-router-dom"
import { useSelector, connect, useDispatch } from "react-redux"
import Select from "react-select"
import { Row, Col, UncontrolledTooltip, Table, Input, Button } from "reactstrap"
//import * as quotationAction from "../../store/cXVvdGF0/actions"
import * as specialAction from "../../store/c3BlY2lhbGlu/actions"
import { toast, ToastContainer } from "react-toastify"
import { isEmpty, get } from "lodash"
import PropTypes from "prop-types"
import * as followupAction from "../../store/Zm9sbG93dXA/actions"
import Modal from "react-bootstrap/Modal"
import SimpleReactValidator from "simple-react-validator"

const SpecialInstruction = (props) => {
  const specificDispatch = useDispatch()
  let { id } = useParams()
  const { dispatch, clientProfile, location, modeMenu } = props
  const update = useSelector((state) => state.session)
  console.log(update, "myUpdate")
  console.log(modeMenu, "mymodeMenu")
  const { user = [] } = update

  //Valdiations
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  const qcSentProcessStatus =
    !isEmpty(clientProfile) && clientProfile.leadDetails
      ? clientProfile.leadDetails[0].processStatus
      : []
  console.log(qcSentProcessStatus, "qcSentProcessStatus")

  const salesManagerId = !isEmpty(user) && user.roleId

  const salesManagerRoleId =
    !isEmpty(location) && location && location.id
      ? location.id.managerId
      : salesManagerId

  const managerView = salesManagerRoleId === "6320da65812dfec5383565f4"

  useEffect(() => {
    dispatch(specialAction.loadInstructions(id))
    dispatch(followupAction.loadRecordsLeadCarryForwardListData({ leadId: id }))
    dispatch(specialAction.loadRecordsMetaData())
  }, [])

  const instructionUpdate = useSelector(
    (specificState) => specificState.special_instruction
  )

  const followupUpdate = useSelector((specificState) => specificState.followup)
  const { leadCarryForwardList = [] } = followupUpdate

  const leadCarryForwardListSpecialInstruction = get(
    leadCarryForwardList,
    "specialInstruction",
    []
  )
  const { instructions = [], recordsMetaData = {} } = instructionUpdate
  console.log(instructionUpdate, "update is")
  console.log(instructions, "instructions")
  console.log(
    leadCarryForwardListSpecialInstruction,
    "Carry ForwardList SpecialInstructions"
  )

  //Special Instructions

  const [specialInstructionSet, setSpecialInstructionSet] = useState(false)

  const [instructionsList, setInstructionsList] = useState({
    departmentId: "",
    teamId: "",
    remarks: "",
  })

  const instructionsChange = (e) => {
    setInstructionsList({
      ...instructionsList,
      [e.target.name]: e.target.value,
    })
  }

  const [department, setDepartment] = useState([])
  const [team, setTeam] = useState([])
  const [renderPage, setRenderPage] = useState(false)
  const [updateInstruction, setUpdateInstruction] = useState(false)
  const [deleteInstructionsForm, setDeleteInstructionsForm] = useState(false)

  const handleInstructionsClose = () => setDeleteInstructionsForm(false)

  const addSpecialInstruction = () => {
    setInstructionsList({
      departmentId: "",
      teamId: "",
      remarks: "",
    })
    setDepartment([])
    setTeam([])
    setSpecialInstructionSet(true)
    setRenderPage(!renderPage)
  }

  const handleInstructions = (success) => {
    if (simpleValidator.current.allValid()) {
      const instructionUpdate = {
        leadId: id,

        specialInstruction: [
          {
            departmentId: department.value,
            teamId: team.value,
            remarks: instructionsList.remarks,
            mode: "Ec",
          },
        ],
      }
      specificDispatch(
        specialAction.createInstruction(instructionUpdate, success)
      )
      setTimeout(() => {
        specificDispatch(specialAction.loadInstructions(id))
        dispatch(
          followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
        )
        setSpecialInstructionSet(false)
        toast.success("Special Instruction Added successfully")
      }, 2000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setSpecialInstructionSet(true)
    }
  }

  const editInstructions = (item) => {
    setDepartment({ label: item.departmentName, value: item.departmentId })
    setTeam({ label: item.teamName, value: item.teamId })

    setInstructionsList({
      ...instructionsList,
      leadId: id,
      specialInstructionsId: item._id,
      departmentId: [{ value: item.departmentId }],
      departmentName: [{ label: item.departmentName }],
      teamId: [{ value: item.teamId }],
      teamName: [{ label: item.teamName }],
      remarks: item.remarks,
    })

    setUpdateInstruction(true)
    setSpecialInstructionSet(true)
  }

  useEffect(() => {
    instructionsList
  }, [instructionsList])

  const updateInstructions = (record, success) => {
    const instructionUpdate = {
      leadId: instructionsList.leadId,
      leadQuotationSpecialInstructionId: instructionsList.specialInstructionsId,
      specialInstruction: {
        departmentId: department.value,
        teamId: team.value,
        remarks: instructionsList.remarks,
      },
    }

    specificDispatch(
      specialAction.updateInstruction(instructionUpdate, record, success)
    )

    setTimeout(() => {
      specificDispatch(specialAction.loadInstructions(id))
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
      setUpdateInstruction(false)
      setSpecialInstructionSet(false)
      toast.success("Special Instruction Updated successfully")
    }, 2000)
  }

  const [instructionsId, setInstructionsId] = useState("")

  const removeSpecialInstruction = (success) => {
    const leadId = id
    const leadQuotationSpecialInstructionId = instructionsId

    specificDispatch(
      specialAction.deleteInstruction(
        leadId,
        leadQuotationSpecialInstructionId,
        success
      )
    )
    setTimeout(() => {
      specificDispatch(specialAction.loadInstructions(id))
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
      toast.success("Special Instruction Deleted successfully")
    }, 1000)
  }

  return (
    <React.Fragment>
      <Row className="quote-head-content">
        <Col lg="9" md="9" sm="6" xs="6">
          <p className="quote-head">
            Special Instruction
            <span className="quote-info">
              <i
                style={{ color: "grey" }}
                id="quoteInfo1"
                aria-hidden="true"
                className="fa fa-info-circle ms-1"
              ></i>
              <UncontrolledTooltip placement="right" target="quoteInfo1">
                Special Instruction
              </UncontrolledTooltip>
            </span>
          </p>
        </Col>
        <Col lg="3" md="3" sm="6" xs="6">
          {managerView ||
          qcSentProcessStatus === "PS8" ||
          qcSentProcessStatus === "PS6" ||
          // qcSentProcessStatus === "PS17" ||
          qcSentProcessStatus === "PS9" ||
          modeMenu === "EventComplete" ? (
            ""
          ) : (
            <div
              className="add-more-instructions"
              onClick={() => {
                addSpecialInstruction()
              }}
            >
              Add More
            </div>
          )}
        </Col>
      </Row>
      {specialInstructionSet && (
        <Col md="12" xl="12" lg="12" className="mt-3">
          <Table>
            <tbody>
              <tr>
                <td style={{ width: "25%" }}>
                  <Select
                    name="department"
                    value={department}
                    options={
                      recordsMetaData ? recordsMetaData.departmentOptions : []
                    }
                    placeholder="Select Department"
                    onChange={(e) => setDepartment(e)}
                  />
                  {simpleValidator.current.message(
                    "department",
                    department,
                    "required"
                  )}
                </td>
                <td style={{ width: "25%" }}>
                  <Select
                    name="team"
                    value={team}
                    options={recordsMetaData ? recordsMetaData.teamOptions : []}
                    placeholder="Select Team"
                    onChange={(e) => setTeam(e)}
                  />
                  {simpleValidator.current.message("team", team, "required")}
                </td>
                <td style={{ width: "20%" }}>
                  <Input
                    name="remarks"
                    value={instructionsList.remarks}
                    onChange={(e) => instructionsChange(e)}
                    placeholder="Enter Remarks"
                  />
                  {simpleValidator.current.message(
                    "remarks",
                    instructionsList.remarks,
                    "required"
                  )}
                </td>

                {updateInstruction ? (
                  <td style={{ width: "15%" }}>
                    <div className="d-flex flex-row">
                      <div
                        className="add-button btn btn-danger"
                        onClick={() => {
                          setUpdateInstruction(false)
                          setSpecialInstructionSet(false)
                        }}
                      >
                        cancel
                      </div>
                      <div
                        className="add-button btn btn-success"
                        onClick={() => updateInstructions()}
                      >
                        update
                      </div>
                    </div>
                  </td>
                ) : (
                  <td style={{ width: "15%" }} className="w-10">
                    <div className="d-flex flex-row">
                      <div
                        className="add-button btn btn-danger"
                        onClick={() => {
                          setSpecialInstructionSet(false)
                        }}
                      >
                        cancel
                      </div>
                      <div
                        className="add-button btn btn-success"
                        onClick={() => handleInstructions()}
                      >
                        Add
                      </div>
                    </div>
                  </td>
                )}
              </tr>
            </tbody>
          </Table>
        </Col>
      )}
      <Row>
        <Col className="mt-3">
          <Table bordered responsive>
            <thead style={{ backgroundColor: "#f9f9f9" }}>
              <tr>
                <th>Department</th>
                <th>Team</th>
                <th>Special Instructions</th>
                <th className="icon-section" style={{ textAlign: "center" }}>
                  #
                </th>
                <th className="icon-section">#</th>
              </tr>
            </thead>
            <tbody>
              {!isEmpty(leadCarryForwardListSpecialInstruction) &&
              leadCarryForwardListSpecialInstruction.length > 0 ? (
                leadCarryForwardListSpecialInstruction.map((item, index) => {
                  if (item.mode === "Ec") {
                    console.log(item, "item")
                    return (
                      <>
                        <tr key={index}>
                          <td>
                            {!isEmpty(item) && item.departmentName
                              ? item.departmentName
                              : ""}
                          </td>
                          <td>
                            {!isEmpty(item) && item.teamName
                              ? item.teamName
                              : ""}
                          </td>
                          <td>
                            {!isEmpty(item) && item.remarks ? item.remarks : ""}
                          </td>
                          <td>
                            {managerView ||
                            qcSentProcessStatus === "PS8" ||
                            qcSentProcessStatus === "PS6" ||
                            // qcSentProcessStatus === "PS17" ||
                            qcSentProcessStatus === "PS9" ? (
                              <button
                                type="submit"
                                className="add-button disabled-button"
                                disabled
                                onClick={() => {
                                  editInstructions(item)
                                }}
                              >
                                Edit
                              </button>
                            ) : (
                              <button
                                type="submit"
                                className="add-button"
                                onClick={() => {
                                  editInstructions(item)
                                }}
                              >
                                Edit
                              </button>
                            )}
                          </td>
                          <td>
                            {managerView ||
                            qcSentProcessStatus === "PS8" ||
                            qcSentProcessStatus === "PS6" ||
                            // qcSentProcessStatus === "PS17" ||
                            qcSentProcessStatus === "PS9" ? (
                              <i
                                className="fa fa-times remove-icon disabled-button"
                                onClick={() => {
                                  setInstructionsId(item._id)
                                  setDeleteInstructionsForm(true)
                                }}
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times remove-icon"
                                onClick={() => {
                                  setInstructionsId(item._id)
                                  setDeleteInstructionsForm(true)
                                }}
                              ></i>
                            )}
                          </td>
                        </tr>
                      </>
                    )
                  }
                })
              ) : (
                <>
                  <tr key={0}>
                    <td colSpan={5} className="text-align-center">
                      No record found
                    </td>
                  </tr>
                </>
              )}
              {!isEmpty(leadCarryForwardListSpecialInstruction) &&
                leadCarryForwardListSpecialInstruction.map((item) => {
                  if (item.mode !== "Ec") {
                    return (
                      <>
                        <tr key={item._id}>
                          <td>
                            {!isEmpty(item) && item.departmentName
                              ? item.departmentName
                              : ""}
                          </td>
                          <td>
                            {!isEmpty(item) && item.teamName
                              ? item.teamName
                              : ""}
                          </td>
                          <td>
                            {!isEmpty(item) && item.remarks ? item.remarks : ""}
                          </td>
                          <td>
                            <button
                              type="submit"
                              className="add-button disabled-button"
                              disabled
                              onClick={() => {
                                editInstructions(item)
                              }}
                            >
                              Edit
                            </button>
                          </td>
                          <td>
                            <i
                              className="fa fa-times remove-icon disabled-button"
                              disabled
                              onClick={() => {
                                setInstructionsId(item._id)
                                setDeleteInstructionsForm(true)
                              }}
                            ></i>
                          </td>
                        </tr>
                      </>
                    )
                  }
                })}
            </tbody>
          </Table>
        </Col>
        {deleteInstructionsForm && (
          <Modal show={deleteInstructionsForm} onHide={handleInstructionsClose}>
            <Modal.Header>Delete Special Instructions</Modal.Header>
            <Modal.Body>
              Do you want to delete the Special Instructions ?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleInstructionsClose}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => {
                  handleInstructionsClose()
                  removeSpecialInstruction()
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}

SpecialInstruction.propTypes = {
  dispatch: PropTypes.func,
  clientProfile: PropTypes.array,
  location: PropTypes.array,
  modeMenu: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SpecialInstruction)
)
